import { useQuery, gql } from '@apollo/client';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
const fetchAssociationTypesBetweenObjectTypesQuery = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"fetchAllAssociationTypesBetweenObjectTypes\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"allAssociationTypesBetweenObjectTypes\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectType\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectTypeId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectType\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associationCategory\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associationTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hasAllAssociatedObjects\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"isPrimary\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeDefinition\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"permissioningType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"pluralForm\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readScopeName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"singularForm\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"inverseHasAllAssociatedObjects\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"inverseAssociationTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"inverseLabel\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "fetchAllAssociationTypesBetweenObjectTypes"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "fromObjectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "toObjectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "allAssociationTypesBetweenObjectTypes"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "fromObjectType"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "fromObjectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "toObjectType"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "toObjectTypeId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "associationCategory"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "associationTypeId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "hasAllAssociatedObjects"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isPrimary"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "toObjectTypeDefinition"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "permissioningType"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "pluralForm"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "readScopeName"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "singularForm"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "inverseHasAllAssociatedObjects"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "inverseAssociationTypeId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "inverseLabel"
            }
          }]
        }
      }]
    }
  }]
});
export function buildAssociationTypes(associationTypes, error, loading) {
  const primaryAssociationType = associationTypes.find(({
    isPrimary
  }) => isPrimary);
  const unlabeledAssociationType = associationTypes.find(({
    hasAllAssociatedObjects
  }) => hasAllAssociatedObjects);
  const inverseUnlabeledAssociationType = {
    associationCategory: unlabeledAssociationType && unlabeledAssociationType.associationCategory,
    associationTypeId: unlabeledAssociationType && unlabeledAssociationType.inverseAssociationTypeId
  };
  return {
    associationTypes,
    associationTypesError: error,
    associationTypesLoading: loading,
    inverseUnlabeledAssociationType,
    primaryAssociationType,
    unlabeledAssociationType
  };
}
const useFetchAssociationTypesData = ({
  fromObjectTypeId,
  toObjectTypeId
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(fetchAssociationTypesBetweenObjectTypesQuery, {
    variables: {
      fromObjectTypeId: normalizeTypeId(fromObjectTypeId),
      toObjectTypeId: normalizeTypeId(toObjectTypeId)
    }
  });
  if (loading || error || !data) {
    return {
      associationTypesLoading: loading,
      associationTypesError: error,
      associationTypes: [],
      inverseUnlabeledAssociationType: undefined,
      primaryAssociationType: undefined,
      unlabeledAssociationType: undefined
    };
  }
  const {
    associationTypes,
    inverseUnlabeledAssociationType,
    primaryAssociationType,
    unlabeledAssociationType
  } = buildAssociationTypes(data.allAssociationTypesBetweenObjectTypes || [], error, loading);
  return {
    associationTypes,
    associationTypesError: error,
    associationTypesLoading: loading,
    inverseUnlabeledAssociationType,
    primaryAssociationType,
    unlabeledAssociationType
  };
};
export default useFetchAssociationTypesData;